import React from "react";
import { Link } from "react-router-dom";
import { Col, Container, Row } from "reactstrap";

// Import Images
import logolight from "../../../assets/images/logo-dark.png";

const Footer = () => {
  return (
    <React.Fragment>
      <footer className="custom-footer bg-dark py-5 position-relative">
        <Container>
          <Row>
            <Col lg={7} className="mt-4">
              <div>
                <div>
                  <img src={logolight} alt="logo light" height="50" />
                </div>
                <div className="mt-4">
                  <p className="ff-secondary">
                    A Fort é uma exchange que permite que
                    você negocie criptomoedas diretamente, sem
                    intermediários, de forma rápida, segura e eficiente. Faça
                    parte da Fort Exchange e descubra como é simples e seguro
                    negociar criptomoedas em uma plataforma de confiança.
                  </p>

                  <p>
                    O futuro das negociações de criptomoedas é {" "}
                    <b className="text-warning">Fort Exchange</b>.
                  </p>
                </div>
              </div>
            </Col>

            <Col lg={2} className="ms-lg-auto"></Col>

            <Col lg={3} className="ms-lg-auto">
              <Row>
                <Col sm={12} className="mt-4">
                  <h5 className="text-white mb-0">Sobre nós</h5>
                  <div className="text-muted mt-3">
                    <ul className="list-unstyled ff-secondary footer-list">
                      <li>
                        <Link to="https://fort.exchange/">Site</Link>
                      </li>
                      <li>
                        <Link to="https://painel.fort.exchange/">
                          Cadastro PF
                        </Link>
                      </li>
                      <li>
                        <Link to="https://fort.exchange/cadastro-pj/">
                          Cadastro PJ
                        </Link>
                      </li>
                      <li>
                        <Link to="https://fort.exchange/blog/">Blog</Link>
                      </li>
                    </ul>
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>

          <Row className="text-center text-sm-start align-items-center mt-5">
            <Col sm={6}>
              <div>
                <p className="copy-rights mb-0">
                  {new Date().getFullYear()} © Fort Exchange
                </p>
              </div>
            </Col>
            <Col sm={6}>
              <div className="text-sm-end mt-3 mt-sm-0">
                <ul className="list-inline mb-0 footer-social-link">
                  <li className="list-inline-item">
                    <Link
                      to="http://www.facebook.com/fortexchange"
                      className="avatar-xs d-block"
                    >
                      <div className="avatar-title rounded-circle">
                        <i className="ri-facebook-fill"></i>
                      </div>
                    </Link>
                  </li>
                  <li className="list-inline-item">
                    <Link
                      to="https://www.instagram.com/fort_exchange"
                      className="avatar-xs d-block"
                    >
                      <div className="avatar-title rounded-circle">
                        <i className="ri-instagram-fill"></i>
                      </div>
                    </Link>
                  </li>
                  <li className="list-inline-item">
                    <Link
                      to="https://www.linkedin.com/company/fort-exchange/"
                      className="avatar-xs d-block"
                    >
                      <div className="avatar-title rounded-circle">
                        <i className="ri-linkedin-fill"></i>
                      </div>
                    </Link>
                  </li>
                  <li className="list-inline-item">
                    <Link
                      to="https://api.whatsapp.com/send?phone=5516996188872&text=Ol%C3%A1,%20quero%20saber%20mais%20sobre%20a%20Fort%20Exchange"
                      className="avatar-xs d-block"
                    >
                      <div className="avatar-title rounded-circle">
                        <i className="ri-whatsapp-line"></i>
                      </div>
                    </Link>
                  </li>
                </ul>
              </div>
            </Col>
          </Row>
        </Container>
      </footer>
    </React.Fragment>
  );
};

export default Footer;
